import React from 'react'
import Text from './../../shared/components/LayoutComponents/Text'
import Swiper from '../../shared/components/FormComponents/SwiperComponent'
import TextImage from '../../shared/components/LayoutComponents/TextImage'
import MasonryComponent from '../../shared/components/FormComponents/MasonryComponent'
import FeedbackContent from '../Feedback/FeedbackContent'

export interface Props {
  reloadFeedback: () => void
}

const Home: React.FC<Props> = (props) => {
  return (
    <>
      <>

        <Text
        columns={1}
        elements={
          [
            { headline1: 'Girls Day bei 3m5', content: '' },
          ]
        }
      /> <Text
        columns={1}
        elements={
          [
            { headline2: 'Unsere eigene Webseite', content: 'Wir haben beim Girls Day im Unternehmen 3m5 eine eigene Webseite programmiert. Mit Informationen über das Unternehmen 3m5 und über unseren informativen Tag. Das ist unser Ergebnis :' },

          ]
        }
      />



        <Swiper
          itemData={
            [
              { img: './images/IMG_8289.jpg', title: 'Willkommen' },
              { img: './images/PXL_20250403_092107943.jpg', title: 'Programmieren' },
              { img: './images/PXL_20250403_095518354.jpg', title: 'Interwiev' },
              { img: './images/PXL_20250403_100817506.jpg', title: 'Pizza' },
              { img: './images/PXL_20250403_115453672.jpg', title: 'Programmieren' },
              { img: './images/IMG_8339.jpg', title: 'Programmieren' },
              { img: './images/IMG_8334.jpg', title: 'Felix' },
            ]
          }
        />


        <Text
        columns={2}
        elements={
          [
            { headline2: '3m5', content: 'Im Jahr 1997 beginnt die Geschichte von 3m5., als zwei Studenten in einem Wohnheimzimmer ihre Internetfirma gründen. Heute arbeiten rund 65 Menschen für das Unternehmen, das sich um die Digitalisierung von Global Playern, großen Marken und starken Mittelständlern kümmert. ' },
            { headline2: 'Girls Day', content: 'Der Girls\'Day ist ein bundesweiter Orientierungstag zur Berufs- und Studienorientierung von Mädchen. Am Girls\'Day lernen Mädchen Berufe oder Studienfächer kennen, in denen der Frauenanteil unter 40 Prozent liegt, z. B. in den Bereichen IT, Handwerk, Naturwissenschaften und Technik.' },
          ]
        }
      />




        <Text
          columns={3}
          elements={
            [
              { headline2: 'Teilnehmende Schulen', content: '' },
            ]
          }
        />
        <Text
          columns={3}
          elements={
            [
              { headline3: 'Gymnasium Dresden Bühlau', content: 'Wir gestalten unsere Schule als offenen Lern- und Lebensraum. Wir begleiten junge Menschen auf ihrem Weg zu einer gereiften und selbstbestimmten Persönlichkeit. gdb = gestalte deine bildung. \n' +
                  'Projekte: Schulkulturfest, genial-sozial, English in action, Jugendforscht und vieles mehr.',
                imagePath: './images/gdb.png'},
              { headline3: 'SUFW Dresden e.V.', content: 'Das Sächsische Umschulungs- und Fortbildungswerk Dresden e. V. (SUFW) ist seit 1990 ein anerkannter Anbieter von Berufsorientierung, Schulsozialarbeit, Praxisberatung und Inklusion, Berufsvorbereitung, Aus- und Weiterbildung, sowie Aktivierungs-, Beschäftigungs- und Vermittlungsmaßnahmen. Zudem ist das SUFW in der Jugend- und Familienarbeit sowie in verschiedenen Migrationsprojekten aktiv.'
                ,imagePath:'./images/SUFW.png' },
              { headline3: 'Gms Campus cordis', content: 'Unsere Schule ist ein Ort des Lernens, der Entfaltung und der Gemeinschaft. Hier legen wir großen Wert darauf, unsere Schülerinnen und Schüler bestmöglich auf ihren Bildungsweg vorzubereiten.'
                ,imagePath:'./images/Gms.png' },
            ]
          }
        />
      </>
    </>
  )
}
export default Home
